import type { TestimonialsSection } from '@/data/types';
import testimonialsDataJson from '@/data/testimonials.json';

export function useTestimonialsData() {
  const testimonialsData = testimonialsDataJson as TestimonialsSection;
  return { testimonialsData, loading: false, error: null };
}